import { PreviewModalComponent } from './preview-modal.component';

export default angular
  .module('sfMobile.components.preview-modal', [])
  .component('sfPreviewModal', PreviewModalComponent).name;
